import {
  PresaleTxSignerRequest,
  PresaleTxSignerResponse,
  TxSignerRequest,
  TxSignerResponse,
} from '../interfaces'
import { POST, POSTWithAuth } from './Index'

export async function txSigner(tx_data: string): Promise<TxSignerResponse> {
  return await POST<TxSignerRequest, TxSignerResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/txsigner`,
    {
      tx_data,
    }
  )
}

export async function presaleTxSigner(
  tx_data: string,
  mint: string
): Promise<PresaleTxSignerResponse> {
  return await POSTWithAuth<PresaleTxSignerRequest, PresaleTxSignerResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/txsigners/primary`,
    {
      tx_data,
      mint,
    }
  )
}
